module.exports = __webpack_public_path__ + "themes/fq/img/wheel1@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/wheel1@2x.png
// module id = 69
// module chunks = d-game